import React from "react";
import { Tabs, Tab, withStyles } from "@material-ui/core";

export const SmallerTabs = withStyles((theme) => ({
  indicator: {
    "& > div": {
      width: "100%",
      maxWidth: 64,
    },
  },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

export const SmallerTab = withStyles((theme) => ({
  root: {
    minWidth: 64,
    textTransform: "none",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  selected: {
    color: "#007e8f",
    fontWeight: `700 !important`
  },
}))((props) => <Tab {...props} />);

export const SmallerTabsV2 = withStyles((theme) => ({
  indicator: {
    visibility: "hidden",
  },
  root: {
    minHeight: 44,
  },
}))((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

export const SmallerTabV2 = withStyles((theme) => ({
  root: {
    minWidth: 64,
    minHeight: 44,
    textTransform: "none",
    marginLeft: theme.spacing(0.625),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  selected: {
    background: theme.palette.primary.lightGrey,
    borderRadius: "8px",
  },
}))((props) => <Tab {...props} />);

export default { SmallerTabs, SmallerTab, SmallerTabsV2, SmallerTabV2 };
